import { createContext, useState } from 'react';

export function useHeroIntersection() {
  const [isIntersecting, setIsIntersecting] = useState(true);
  return {
    isIntersecting,
    setIsIntersecting,
  };
}

const HeroContext = createContext({
  isIntersecting: true,
  setIsIntersecting: () => {},
});

export default HeroContext;
